module.exports = "/fonts/boxicons.woff2?1ec26ee17fd6b5903e74b8a599166a22";